import { create } from 'zustand';

/**
 * Cross-page UI state for Graph & Projects. Not persisted: a filter that
 * survives a restart makes a graph look broken for a reason nobody remembers
 * (the boardsUiStore precedent).
 *
 * `graphVersion` is bumped by every projects/links write so the graph rebuilds
 * at once instead of waiting for another store to change.
 */
export const useGraphUiStore = create((set) => ({
  graphVersion: 0,
  bumpGraph: () => set((s) => ({ graphVersion: s.graphVersion + 1 })),

  // An SSH/SFTP host the user asked to open: SshHostChoiceModal asks how.
  sshChoice: null,
  requestSshChoice: (node) => set(() => ({ sshChoice: node || null })),
  clearSshChoice: () => set(() => ({ sshChoice: null })),

  // Graph toolbar "Scope": null = everything, else a wire scope
  // (`personal` | `team:<id>`). Not persisted. The PROJECT is the shared
  // toolbar scope (graph/graphProjectScope.js, card 6.2), not state here.
  scopeFilter: null,
  setScopeFilter: (scope) => set(() => ({ scopeFilter: scope || null })),

  focusNodeId: null,
  requestFocus: (nodeId) => set(() => ({ focusNodeId: nodeId || null })),
  clearFocus: () => set(() => ({ focusNodeId: null })),
}));

export const bumpGraph = () => useGraphUiStore.getState().bumpGraph();
